import React, { useCallback, useEffect, useMemo, useState } from "react";
import '../../CSS/Estilo.css'
import axios from "axios";
import { nanoid } from "nanoid";
import DropZone from "./DropZone";
import FilesList from "./FileList";


export default function FilePicker({ accept, uploadURL,user,directory }) {

  const [files, setFiles] = useState([]);
  const [progress, setProgress] = useState(0);
  const [uploadStarted, setUploadStarted] = useState(false);
  const [dropVisible, setDropVisible] = useState(true);
  const [errorSubida, setErrorSubida] = useState(false);

  // Manejador del componente DropZone llamado cuando hay ficheros seleccionados
  const handleOnChange = useCallback((files) => {
    let filesArray = Array.from(files);
    filesArray = filesArray.map((file) => ({
      id: nanoid(),
      file,
    }));
    setFiles(filesArray);
    setProgress(0);
    setUploadStarted(false);
    setDropVisible(()=>false);
  }, []);

  // Manejador para eliminar ficheros de la lista de ficheros
  const handleClearFile = useCallback((id) => {
    setFiles((prev) => prev.filter((file) => file.id !== id));
  }, []);

  // Mostrar o no la barra de progreso
  const canShowProgress = useMemo(() => files.length > 0, [files.length]);

  const FICHEROWEB = "FicheroWeb";
  const FOTOSWEB = "FotosWeb";
  const ANUNCIOSWEB = "AnuncioWeb";

  // Ejecuta la operacion de subida de ficheros
  const handleUpload = useCallback(async () => {
    setErrorSubida(()=>false);
    //Comprobar que hay una descripción para cada fichero y obtenerla
    let lista = document.getElementById('listaFicheros');
    let entradasLista = Array.from(lista.children);
    let descripciones = [];
    let compartirConTodos = [];
    let usuariosACompartir = [];
    let todoCorrecto = true;
    entradasLista.forEach((entrada, index) => {
      let desc = entrada.children[1].value;
      //Si se trata de un fichero especial ( paquete zip o Anuncio pdf ) con un nuevo contenido
      if(desc.includes(FICHEROWEB) || desc.includes(FOTOSWEB) || desc.includes(ANUNCIOSWEB))
      {
        //Determinar la clave de fichero especial con que se esta subiendo el fichero
        let special_key = "";
        if(desc.includes(FICHEROWEB))
          special_key = FICHEROWEB;
        else if(desc.includes(FOTOSWEB))
          special_key = FOTOSWEB;
        else
          special_key = ANUNCIOSWEB;
            const sufix = "Debe ser: "+special_key+"-yyyy-mm-dd";
            //En este caso, solo se puede subir un fichero
            if(entradasLista.length > 1)
            {
              if(special_key === FICHEROWEB || special_key === FOTOSWEB)
                alert("Solo se puede subir un único fichero especial zip.");
              else
                alert("Solo se puede subir un único fichero pdf");
              todoCorrecto = false;
            }
            //Comprobar que el fichero contiene un guión después de la palabra clave
            if(desc[special_key.length] !== '-')
            {
              alert("Formato de descripción de fichero especial no válido."+sufix);
              todoCorrecto = false;
            }
            //Comprobar que el fichero contiene una fecha válida después del guion
            let dateString = desc.substring(special_key.length+1);
            const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
            if(!regex.test(dateString))
            {
              alert("Fecha: "+dateString+" no válida. Se requiere fecha ISO: yyyy-mm-dd después de: "+special_key+"-");
              todoCorrecto = false;
            }
      }
      //alert(entrada.children[2].children.length);
      let compartido = entrada.children[2].children[2].checked;
      let usuarioscompartir = entrada.children[2].children[4].value;
      //alert("Compartido: " + compartido + " Usuarios: " + usuarioscompartir);
      if (desc.length === 0) {
        let textoInterno = (lista.children.item(index).innerText).split('\n');
        alert("La descrición del fichero: " + textoInterno[0] + " no puede estar vacia ");
        lista.children.item(index).focus();
        setUploadStarted(() => false);
        setProgress(() => 0);
        todoCorrecto = false;
      } else {
        descripciones.push(desc);
        compartirConTodos.push(compartido);
        usuariosACompartir.push(usuarioscompartir);
      }
    });
    if(!todoCorrecto)
      return;
    try {
      const data = new FormData();
      //Añadir los ficheros ( estaran en req.files del servidor )
      files.forEach((file,index) => {
        data.append("file", file.file);
      });
      //Añadir el token de usuario actual ( estará en req.body.user del servidor )
      data.append('user', user);
      data.append('descripciones',descripciones);
      data.append('compartido',compartirConTodos);
      data.append('listaCompartidos',usuariosACompartir);
      const res = await axios.request({
        url: uploadURL,
        method: "POST",
        data,
        onUploadProgress: (progressEvent) => {
          setUploadStarted(true);
          const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        },
      }).then((response) => {
        if(response.data.substring(0,5) === "Error")
          setErrorSubida(()=>true);
        alert(response.data);
      });
    } catch (error) {
      console.log(error);
    }
  }, [files.length]);

  // Poner progress a cero cuando no hay ficheros
  useEffect(() => {
    if (files.length < 1) {
      setProgress(0);
    }
  }, [files.length]);

  // Poner uploadStarted a false cuando la subida esté completada
  useEffect(() => {
    if (progress === 100) {
      setUploadStarted(false);
    }
  }, [progress]);

  const uploadComplete = useMemo(() => progress === 100, [progress]);

  return (
      <div className={'wrapper'}>
        {/* canvas */}
        {dropVisible && <div className={'canvas_wrapper'}>
          <DropZone onChange={handleOnChange} accept={accept} directory={directory}/>
        </div>}

        {/* files listing */}
        {files.length ? (
            <div className={'files_list_wrapper'}>
              <FilesList
                  files={files}
                  onClear={handleClearFile}
                  uploadComplete={uploadComplete && !errorSubida}
              />
            </div>
        ) : null}

        {/* progress bar */}
        {canShowProgress ? (
            <div className={'files_list_progress_wrapper'}>
              <progress value={progress} max={100} style={{width: "100%"}}/>
            </div>
        ) : null}

        {/* upload button */}
        {files.length ? (
            <button
                onClick={handleUpload}
                className={!errorSubida && (uploadComplete || uploadStarted) ? "btDeshabilitado" : "btOperativo"}
                disabled={!errorSubida && (uploadComplete || uploadStarted)}
            >
              {!errorSubida && (uploadComplete||uploadStarted)?`Subidos ${files.length} ficheros`:`Subir ${files.length} ficheros`}
            </button>
        ) : null}
      </div>
  );
};